export default __webpack_public_path__ + "static/media/suspended.da817ed4.svg";